
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[...id]",
      function () {
        return require("private-next-pages/events/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[...id]"])
      });
    }
  